import { Grid, useCombobox, Group, Title } from "@mantine/core";
import { observer } from "mobx-react-lite";
import { RealTimeDisplayHeader } from "../components/RealTimeDisplay";
import DashboardIcon from "../assets/icons/DashboardIcon";

const Overview: React.FC = observer(() => {
  const combobox = useCombobox({
    onDropdownClose: () => {
      combobox.resetSelectedOption();
    },
  });

  const header = <RealTimeDisplayHeader />;
  const body = "Elv management";

  return (
    <>
      <Grid>
        <Grid.Col span={2}>
          <Group gap="xs" mt={18}>
            <DashboardIcon color="#7033FC" />
            <Title order={2} mt={4}>
              Overview
            </Title>
          </Group>
        </Grid.Col>
        <Grid.Col span={8}>{header}</Grid.Col>
        <Grid.Col span={12}>{body}</Grid.Col>
      </Grid>
    </>
  );
});

export default Overview;
